<template>
  <footer>
    <div class="flex list-none m-2rem mt-4rem gap-1rem text-end justify-end items-end animate-fade-in animate-ease">
      <a class="i-simple-icons-x" href="https://x.com/imshirok1">X account of shirok1</a>
      <a class="i-simple-icons-github" href="https://github.com/shirok1">GitHub account of shirok1</a>
    </div>
  </footer>
</template>
